import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import storycraftLogo from "@/assets/storycraft-logo-new.png";

export const Navbar = () => {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <nav
      className="fixed top-0 left-0 right-0 z-50"
      style={{
        background: "rgba(255, 255, 255, 0.95)",
        backdropFilter: "blur(12px)",
        borderBottom: "1px solid #E5E7EB",
      }}
    >
      <div className="max-w-[1400px] mx-auto pl-2 pr-2 py-4">
        <div className="flex items-center justify-between">
          {/* Left: Logo */}
          <Link to="/" className="flex items-center gap-2.5 group shrink-0">
            <img
              src={storycraftLogo}
              alt="AI StoryCraft Studio"
              className="w-10 h-10 rounded-lg object-contain"
            />
            <span
              className="font-display text-xl font-bold hidden sm:block"
              style={{ color: "#111827" }}
            >
              AI StoryCraft Studio
            </span>
          </Link>

          {/* Center: Nav Links */}
          <div className="hidden md:flex items-center gap-10 absolute left-1/2 -translate-x-1/2">
            <button
              onClick={() => scrollTo("features")}
              className="text-base font-medium transition-colors hover:text-[#7C3AED]"
              style={{ color: "#6B7280" }}
            >
              Tools
            </button>
            <button
              onClick={() => scrollTo("testimonials")}
              className="text-base font-medium transition-colors hover:text-[#7C3AED]"
              style={{ color: "#6B7280" }}
            >
              Reviews
            </button>
            <button
              onClick={() => scrollTo("pricing")}
              className="text-base font-medium transition-colors hover:text-[#7C3AED]"
              style={{ color: "#6B7280" }}
            >
              Pricing
            </button>
            <Link
              to="/blog"
              className="text-base font-medium transition-colors hover:text-[#7C3AED]"
              style={{ color: "#6B7280" }}
            >
              Blog
            </Link>
          </div>

          {/* Right: Actions */}
          <div className="flex items-center gap-4">
            <Button
              variant="ghost"
              size="default"
              asChild
              className="text-base font-medium hover:bg-gray-100"
              style={{ color: "#6B7280" }}
            >
              <Link to="/auth">Login</Link>
            </Button>
            <Button
              size="default"
              asChild
              className="bg-[#7C3AED] text-white text-base font-bold hover:bg-[#6D28D9] border-none rounded-lg px-6 py-2.5 h-11"
            >
              <a href="#pricing">Try For Free</a>
            </Button>
          </div>
        </div>
      </div>
    </nav>
  );
};
